import { AxiosError } from "axios";

import { LogOperation } from "../../utils/entities/logOperation";
import api from "../api";
import { returnResponse } from "../utils";

export const HearingService = {
  addUserCustomerConfidentiality: async (payload: {
    hearingId: number;
    userCustomerId: number;
  }) => {
    return await api.post<any>(
      `/v1/HearingUserCustomerConfidentiality/Add`,
      payload,
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      },
    );
  },

  getAllUserCustomerConfidentialityByHearingId: async (hearingId: number) => {
    return await api.get<any>(
      `/v1/HearingUserCustomerConfidentiality/GetAllByHearingId?hearingId=${hearingId}`,
      {
        headers: {
          accept: "*/*",
        },
      },
    );
  },

  deleteUserCustomerConfidentiality: async (id: number) => {
    return await api.delete<any>(
      `/v1/HearingUserCustomerConfidentiality/Delete?id=${id}`,
      {
        headers: {
          accept: "*/*",
        },
      },
    );
  },

  postNewAudience: async (payload: any) => {
    try {
      const { data } = await api.post<any>(`/v1/Hearing/Add`, payload);

      return {
        status: true,
        data: data.data || data,
      };
    } catch (error: any) {
      if (error instanceof AxiosError) {
        const dataMessage = error?.response?.data?.message
          ? [{ message: error?.response?.data?.message }]
          : [];
        const dataErrors = error?.response?.data?.errors || [];
        let messages = null;
        if (dataErrors.length > 0) {
          messages = dataErrors;
        } else if (dataMessage.length > 0) {
          messages = dataMessage;
        }
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "Não foi possível criar audiência",
        });

        return {
          severity,
          status,
          message: message ? message : "Não foi possível criar audiência",
          data,
        };
      }

      return {
        status: false,
        message: "Não foi possível criar audiência",
        data: null,
        severity: "error",
      };
    }
  },

  postNewAudienceCustom: async (content: any, customFields: any[]) => {
    try {
      const { data } = await api.post<any>(`/v1/Hearing/AddCustom`, {
        content,
        customFields,
      });

      return {
        status: true,
        data: data.data || data,
      };
    } catch (error: any) {
      if (error instanceof AxiosError) {
        const dataMessage = error?.response?.data?.message
          ? [{ message: error?.response?.data?.message }]
          : [];
        const dataErrors = error?.response?.data?.errors || [];
        let messages = null;
        if (dataErrors.length > 0) {
          messages = dataErrors;
        } else if (dataMessage.length > 0) {
          messages = dataMessage;
        }
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "Não foi possível criar audiência",
        });

        return {
          severity,
          status,
          message: message ? message : "Não foi possível criar audiência",
          data,
        };
      }

      return {
        status: false,
        message: "Não foi possível criar audiência",
        data: null,
        severity: "error",
      };
    }
  },

  putNewAudience: async (payload: any) => {
    return await api.put<any>(`/v1/Hearing/Update`, payload);
  },

  putNewAudienceCustom: async (content: any, customFields: any[]) => {
    try {
      const { data } = await api.put<any>(`/v1/Hearing/UpdateCustom`, {
        content,
        customFields,
      });

      return {
        status: true,
        data: data.data || data,
      };
    } catch (error: any) {
      if (error instanceof AxiosError) {
        const dataMessage = error?.response?.data?.message
          ? [{ message: error?.response?.data?.message }]
          : [];
        const dataErrors = error?.response?.data?.errors || [];
        let messages = null;
        if (dataErrors.length > 0) {
          messages = dataErrors;
        } else if (dataMessage.length > 0) {
          messages = dataMessage;
        }
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "Não foi possível atualizar audiência",
        });

        return {
          severity,
          status,
          message: message ? message : "Não foi possível atualizar audiência",
          data,
        };
      }

      return {
        status: false,
        message: "Não foi possível atualizar audiência",
        data: null,
        severity: "error",
      };
    }
  },

  getHearingById: async (hearingId: number) => {
    try {
      const { data } = await api.get(
        `/v1/Hearing/GetAllHearingInformationsByHearingId?hearingId=${hearingId}`,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao pegar o video gravado.",
      };
    }
  },
  deleteHearingDto: async (body: any) => {
    try {
      const { data } = await api.delete("/v1/Hearing/DeleteObject", body);

      return {
        success: true,
        body: data,
      };
    } catch (error: any) {
      return {
        success: false,
        body: error.response,
      };
    }
  },
  deleteHearingDelete: async (id: number) => {
    try {
      const { data } = await api.delete(`/v1/Hearing/Delete?id=${id}`);

      return {
        success: true,
        body: data,
      };
    } catch (error: any) {
      return {
        success: false,
        body: error.response,
      };
    }
  },
  deleteHearing: async (authToken: string | null, hearingId: number) => {
    if (!authToken) {
      return {
        status: false,
        message: "Não é possível inativar o registro sem o token correto.",
      };
    }

    if (!hearingId) {
      return {
        status: false,
        message: "Não é possível inativar o registro sem o dado correto",
      };
    }

    try {
      const bodyDeleteHearing = [
        {
          op: "replace",
          value: false,
          path: "active",
        },
      ];
      const { data } = await api.patch(
        `/v1/Hearing/Update?id=${hearingId}`,
        bodyDeleteHearing,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao deletar o registro.",
      };
    }
  },
  createHearingRecord: async (authToken: string, hearingId: number) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }

    if (!hearingId) {
      return {
        status: false,
        message: "Não é possível criar a sala de video sem o id da sala",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/Hearing/CreateMeeting?hearingId=${hearingId}`,
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      console.log(error);

      return {
        status: false,
        message: "Houve um erro ao criar a sala de video.",
      };
    }
  },
  openHearingRecord: async (authToken: string, hearingFileId: number) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }

    if (!hearingFileId) {
      return {
        status: false,
        message: "Não é possível criar a sala de video sem o id da sala",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/Hearing/OpenMeeting?hearingFileId=${hearingFileId}`,
      );
      await LogOperation.postLogOperation("Hearing", 1, 1);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      console.log(error);

      return {
        status: false,
        message: "Houve um erro ao criar a sala de video.",
      };
    }
  },
  getByHearingId: async (authToken: string, hearingId: number) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }

    if (!hearingId) {
      return {
        status: false,
        message: "Não é possível criar a sala de video sem o id da sala",
      };
    }

    try {
      const { data } = await api.get(`/v1/HearingTokens/GetByHearingId`, {
        params: {
          hearingId: hearingId,
        },
      });

      if (data.length > 0) {
        const dataResponse = {
          token: data.authToken,
          sessionToken: data.deviceToken,
          urlModerator: data.internalLink,
          urlAttendee: data.externalLink,
          videoRoom: {
            id: data.roomId,
          },
        };

        return {
          status: true,
          data: dataResponse,
        };
      } else {
        return {
          status: false,
          message: "Nenhuma sala encontrada",
        };
      }
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao criar a sala de video.",
      };
    }
  },
  getByHearingFileId: async (authToken: string, hearingFileId: number) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }

    if (!hearingFileId) {
      return {
        status: false,
        message: "Não é possível criar a sala de video sem o id da sala",
      };
    }

    try {
      const { data } = await api.get(`/v1/HearingTokens/GetByHearingFileId`, {
        params: {
          hearingFileId: hearingFileId,
        },
      });

      if (data.ok === true) {
        const dataResponse = {
          token: data.data.authToken,
          sessionToken: data.data.deviceToken,
          urlModerator: data.data.internalLink,
          urlAttendee: data.data.externalLink,
          videoRoom: {
            id: data.data.roomId,
          },
        };

        return {
          status: true,
          data: dataResponse,
        };
      } else {
        return {
          status: false,
          message: "Nenhuma sala encontrada",
        };
      }
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao criar a sala de video.",
      };
    }
  },

  getAllByFilters: async (placeId: number) => {
    try {
      const { data } = await api.get(
        `/v1/Hearing/GetAllByFilters?placeId=${placeId}&active=true&pageNumber=1&pageSize=200`,
      );
      return {
        status: true,
        data: data.data?.items ?? data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um error ao pegar o placeId",
      };
    }
  },

  getAllByFiltersV2: async (placeId: number, userId: number) => {
    try {
      const { data } = await api.get(`/v1/Hearing/GetAllByFiltersV2`, {
        params: {
          placeId: placeId,
          userId: userId,
          pageNumber: 1,
          pageSize: 200,
        },
      });
      return {
        status: true,
        data: data.data?.items ?? data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um error ao pegar o placeId",
      };
    }
  },

  stopVideoRecording: async (
    roomId: number,
    authToken: string,
    deviceToken: string,
  ) => {
    try {
      if (!authToken || !deviceToken) {
        return {
          status: false,
          message: "Autenticação inválida.",
        };
      }

      const { data } = await api.post(
        `/v1/Hearing/StopVideoRecord`,
        {
          device: LogOperation.getDevice(),
          ip: LogOperation.getMachineIP(),
          logPoliceUnitId: LogOperation.getPoliceUnitId(),
          logUserId: LogOperation.getUserId(),
        },
        {
          params: {
            roomId: roomId,
          },
        },
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao pegar o video gravado.",
      };
    }
  },
  deleteRoom: async (
    roomId: number,
    authToken: string,
    deviceToken: string,
  ) => {
    try {
      if (!authToken || !deviceToken) {
        return {
          status: false,
          message: "Autenticação inválida.",
        };
      }

      const { data } = await api.post(
        `/v1/Hearing/DeleteRoom`,
        {
          device: LogOperation.getDevice(),
          ip: LogOperation.getMachineIP(),
          logPoliceUnitId: LogOperation.getPoliceUnitId(),
          logUserId: LogOperation.getUserId(),
        },
        {
          params: {
            roomId: roomId,
          },
        },
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao pegar o video gravado.",
      };
    }
  },
  startVideoRecording: async (
    roomId: number,
    authToken: string,
    deviceToken: string,
  ) => {
    try {
      if (!authToken || !deviceToken) {
        return {
          status: false,
          message: "Autenticação inválida.",
        };
      }

      const { data } = await api.post(
        `/v1/Hearing/StartVideoRecord`,
        {
          device: LogOperation.getDevice(),
          ip: LogOperation.getMachineIP(),
          logPoliceUnitId: LogOperation.getPoliceUnitId(),
          logUserId: LogOperation.getUserId(),
        },
        {
          params: {
            roomId: roomId,
          },
        },
      );

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  getHearingDto: async (hearingId: number) => {
    try {
      const { data } = await api.get(
        `/v1/Hearing/GetHearingDTO?hearingId=${hearingId}`,
      );

      return {
        success: true,
        body: data.data,
      };
    } catch (error) {
      return {
        success: true,
        body: {},
      };
    }
  },

  getUserInRoom: async (roomId: number) => {
    try {
      const { data } = await api.get(
        `/v1/Hearing/GetUserInRoom?roomId=${roomId}`,
      );

      return {
        success: true,
        body: data,
      };
    } catch (error) {
      return {
        success: true,
        body: {},
      };
    }
  },

  renewTokens: async (authToken: string, roomId: number) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }
    if (!roomId) {
      return {
        status: false,
        message: "Não é possivel fazer o renew token sem o roomid .",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/Hearing/RenewTokens?roomId=${roomId}`,
      );

      const dataResponse = {
        authToken: data.authToken,
        deviceToken: data.deviceToken,
      };

      return {
        status: true,
        data: dataResponse,
      };
    } catch (error) {
      return {
        status: false,
        message: "Houve um erro ao criar a sala de video.",
      };
    }
  },
  // logoutUna: async () => {
  //   try {
  //     if (window.location.hostname === "localhost") {
  //       await api.get(`http://localhost:5173/una/auth/v1/logout`, {});
  //     } else {
  //       const host = import.meta.env.VITE_APP_BASEURL_SITE;
  //       await api.get(`${host}/una/auth/v1/logout`, {});
  //     }
  //   } catch (error) {
  //     /* empty */
  //   }
  // },

  post: async (authToken: string | null, hearingId: any) => {
    if (!authToken) {
      return {
        status: false,
        message:
          "Não é possível criar a sala de video sem o token de autenticação.",
      };
    }
    try {
      const body = {
        ...hearingId,
      };
      const { data } = await api.post<any>(`/v1/Hearing/Add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  getById: async (id: number) => {
    try {
      const { data } = await api.get<any>(`/v1/Hearing/Get?id=${id}`);

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};
